import {splitPath} from './splitPath';

/**
 * Sets the property value at `path` on `object`.  If a portion of the `path` does not exist, it
 * will be created.
 *
 * Note: This method mutates the object.
 *
 * @example
 * const object = { foo: [{ bar: { baz: 3 } }] };
 * set(object, 'foo[0].bar.baz', 4);
 *
 * @function set
 * @param {Object} object The object to modify.
 * @param {string} path The path of the property to set.
 * @param {*} value The value to set.
 */
export default function set(object, path, value) {
	if (!object || !path) return;

	const parts = splitPath(path);

	let here = object;
	let next;
	const {length: partsCount} = parts;
	for (let i = 0; i < partsCount; i++) {
		const shouldSet = i + 1 === partsCount;
		const part = parts[i];
		next = here[part];
		if (!next) {
			const nextNext = parts[i + 1];
			const index = Number.parseInt(nextNext);
			next = here[part] = index == nextNext && !Number.isNaN(index) ? [] : {}; // eslint-disable-line eqeqeq, no-multi-assign
		}
		if (shouldSet) here[part] = value;

		here = next;
	}
}
